import React from 'react';
import { Checkbox } from '@mui/material';

import { CopyNotesContainer, CopyNotesLabel } from '../styles';

const CopyNotes = ({
  shouldCopyNotes,
  setShouldCopyNotes,
}: {
  shouldCopyNotes: boolean;
  setShouldCopyNotes: (shouldCopyNotes: boolean) => void;
}) => {
  return (
    <CopyNotesContainer>
      <Checkbox
        style={{ marginLeft: -11 }}
        checked={shouldCopyNotes}
        onChange={() => setShouldCopyNotes(!shouldCopyNotes)}
      />
      <CopyNotesLabel>Include notes with the copied worksheet</CopyNotesLabel>
    </CopyNotesContainer>
  );
};

export default CopyNotes;
